// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SkusFilterDropdownMenu_filter-menu__uKmC8 {
  border: 0.1rem solid var(--black-ten-opacity);
  border-radius: 1rem;
  padding-block: 1.5rem 0;
  position: absolute;
  top: 9.8rem;
  background-color: #fff;
  z-index: var(--z-filter-menu);
  width: 60rem;
  max-width: 100%;
  max-height: 50rem;
  right: 0;
  display: flex;
  flex-direction: column;
}

.SkusFilterDropdownMenu_filter-menu__loading__cj7NL {
  margin-inline: auto;
  width: 10rem;
  height: 10rem;
}

.SkusFilterDropdownMenu_filter-menu__empty__He22m {
  gap: 2rem;
  padding-block: 2rem;
}

.SkusFilterDropdownMenu_filter-menu__empty__He22m .icon-wrapper {
  padding: 2rem;
}

.SkusFilterDropdownMenu_filter-menu__empty__He22m .icon {
  width: 3rem;
  height: 3rem;
  object-fit: contain;
}

.SkusFilterDropdownMenu_filter-menu__empty__He22m .message {
  font-size: var(--text-sm);
}

.SkusFilterDropdownMenu_filter-menu__search-wrapper__XJO-O {
  flex: 0 0 auto;
  width: 85%;
  margin: 0 auto 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.1rem 3.5rem;
  border-radius: 5rem;
  background-color: var(--gray-extra-light);
}

.SkusFilterDropdownMenu_filter-menu__search-icon__TfVpY {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
}

.SkusFilterDropdownMenu_filter-menu__search-input__Rc1-v {
  flex-grow: 1;
  background-color: var(--gray-extra-light);
  color: var(--gray-extra-dark);
  font-size: var(--text-base);
  font-weight: 500;
}

.SkusFilterDropdownMenu_filter-menu__list__AWkbP {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding-inline: 8rem;
  margin-bottom: 2rem;
  overflow-y: auto;
}

.SkusFilterDropdownMenu_filter-menu__list-item__UlcC8 {
  flex: 1 1 40%;
  display: flex;
  align-items: center;
  gap: 1.2rem;
}

.SkusFilterDropdownMenu_filter-menu__list-item-label__X-7qg {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1.2rem;
  color: #000;
  font-size: var(--text-base);
  font-weight: 500;
}

.SkusFilterDropdownMenu_filter-menu__list-item-label-img__7fdim {
  width: 3rem;
  height: 3rem;
  object-fit: contain;
}

.SkusFilterDropdownMenu_filter-menu__actions__Q0Gr2 {
  /* position: absolute; */
  bottom: 0;
  width: 100%;
  border-radius: 0rem 0rem 1rem 1rem;
  padding: 1.5rem 4rem;
  background-color: var(--white-semi-dark);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5rem;
}

.SkusFilterDropdownMenu_filter-menu__filter-btn__WyLXr {
  padding: 1rem 6rem;
}

.SkusFilterDropdownMenu_filter-menu__clear-btn__m0blB:disabled {
  background-color: transparent;
}

.SkusFilterDropdownMenu_filter-menu__clear-btn__m0blB:disabled:hover {
  background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/components/Skus/SkusFilters/SkusFilterDropdown/SkusFilterDropdownMenu/SkusFilterDropdownMenu.module.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,QAAQ;EACR,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,WAAW;EACX,kCAAkC;EAClC,oBAAoB;EACpB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".filter-menu {\n  border: 0.1rem solid var(--black-ten-opacity);\n  border-radius: 1rem;\n  padding-block: 1.5rem 0;\n  position: absolute;\n  top: 9.8rem;\n  background-color: #fff;\n  z-index: var(--z-filter-menu);\n  width: 60rem;\n  max-width: 100%;\n  max-height: 50rem;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.filter-menu__loading {\n  margin-inline: auto;\n  width: 10rem;\n  height: 10rem;\n}\n\n.filter-menu__empty {\n  gap: 2rem;\n  padding-block: 2rem;\n}\n\n.filter-menu__empty :global(.icon-wrapper) {\n  padding: 2rem;\n}\n\n.filter-menu__empty :global(.icon) {\n  width: 3rem;\n  height: 3rem;\n  object-fit: contain;\n}\n\n.filter-menu__empty :global(.message) {\n  font-size: var(--text-sm);\n}\n\n.filter-menu__search-wrapper {\n  flex: 0 0 auto;\n  width: 85%;\n  margin: 0 auto 2rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.1rem 3.5rem;\n  border-radius: 5rem;\n  background-color: var(--gray-extra-light);\n}\n\n.filter-menu__search-icon {\n  flex-shrink: 0;\n  width: 2rem;\n  height: 2rem;\n}\n\n.filter-menu__search-input {\n  flex-grow: 1;\n  background-color: var(--gray-extra-light);\n  color: var(--gray-extra-dark);\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n\n.filter-menu__list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding-inline: 8rem;\n  margin-bottom: 2rem;\n  overflow-y: auto;\n}\n\n.filter-menu__list-item {\n  flex: 1 1 40%;\n  display: flex;\n  align-items: center;\n  gap: 1.2rem;\n}\n\n.filter-menu__list-item-label {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 1.2rem;\n  color: #000;\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n\n.filter-menu__list-item-label-img {\n  width: 3rem;\n  height: 3rem;\n  object-fit: contain;\n}\n\n.filter-menu__actions {\n  /* position: absolute; */\n  bottom: 0;\n  width: 100%;\n  border-radius: 0rem 0rem 1rem 1rem;\n  padding: 1.5rem 4rem;\n  background-color: var(--white-semi-dark);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5rem;\n}\n\n.filter-menu__filter-btn {\n  padding: 1rem 6rem;\n}\n\n.filter-menu__clear-btn:disabled {\n  background-color: transparent;\n}\n\n.filter-menu__clear-btn:disabled:hover {\n  background-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filter-menu": `SkusFilterDropdownMenu_filter-menu__uKmC8`,
	"filter-menu__loading": `SkusFilterDropdownMenu_filter-menu__loading__cj7NL`,
	"filter-menu__empty": `SkusFilterDropdownMenu_filter-menu__empty__He22m`,
	"filter-menu__search-wrapper": `SkusFilterDropdownMenu_filter-menu__search-wrapper__XJO-O`,
	"filter-menu__search-icon": `SkusFilterDropdownMenu_filter-menu__search-icon__TfVpY`,
	"filter-menu__search-input": `SkusFilterDropdownMenu_filter-menu__search-input__Rc1-v`,
	"filter-menu__list": `SkusFilterDropdownMenu_filter-menu__list__AWkbP`,
	"filter-menu__list-item": `SkusFilterDropdownMenu_filter-menu__list-item__UlcC8`,
	"filter-menu__list-item-label": `SkusFilterDropdownMenu_filter-menu__list-item-label__X-7qg`,
	"filter-menu__list-item-label-img": `SkusFilterDropdownMenu_filter-menu__list-item-label-img__7fdim`,
	"filter-menu__actions": `SkusFilterDropdownMenu_filter-menu__actions__Q0Gr2`,
	"filter-menu__filter-btn": `SkusFilterDropdownMenu_filter-menu__filter-btn__WyLXr`,
	"filter-menu__clear-btn": `SkusFilterDropdownMenu_filter-menu__clear-btn__m0blB`
};
export default ___CSS_LOADER_EXPORT___;
